define([
	"jquery",
	"site/TEKsystems.SitecoreXP.SearchFilter",
	"eventManager",
	"handlebars",
	"site/Components/SearchPaging",
    "site/TEKsystems.SitecoreXP.Analytics",
    "site/TEKsystems.SitecoreXP.VideoModalLightBox"
],
	function ($, searchFilter, eventManager, handlebars, searchPaging, analytics, videoModal) {

        function SearchResult(scope) {
                       
		}

		function AddParamToUrl(url, name, value) {
			if (value == null || value.length == 0) {
				return url;
			}

			if (url[url.length - 1] != '?') {
				url = url + "&";
			}

			return url + name + "=" + value;
		}

        function BuildUrl(url, query) {

			url = AddParamToUrl(url, "q", query);

			return url;
		}

        function InitializeTracking(scope, itemId) {
            analytics.Initialize(scope, itemId);
        }

		return function initSearchResult(args) {

			var headerTemplatesource = $("#search-handlebar-template-header", $(args.source)).html();
			var headerTemplate = handlebars.compile(headerTemplatesource);

			var itemTemplateSource = $("#search-handlebar-template-results", $(args.source)).html();
			var itemTemplate = handlebars.compile(itemTemplateSource);

            this.ReloadSearchResults = function (query, filters) {

                videoModal.InitVideoModal();

                var url = BuildUrl(args.AjaxUrl, query);

                if (args.StateChangeMessagesTransmitting && args.StateChangeMessagesTransmitting.length) {
                    if (query && query.length) {
                        args.StateChangeMessagesTransmitting.forEach(function (eventName) {
                            eventManager.trigger(eventName, self);
                        });
                    }
                }

                $.post(url,
                    { itemId: args.itemId, type: args.type, pageItemId: args.pageItemId },
                    function (data, textStatus, jqXHR) {
                        $("#" + args.containerId).html(headerTemplate(data));
                        $(".tek-search-results", $("#" + args.containerId)).append(itemTemplate(data.SearchResults));

                        resultsCount: data.SearchResults.SearchResults.length;

                        searchPaging.Load(args.scope, data.Paging, args.paginationType, args.itemId, args.pageItemId, args.PageAjaxUrl);

                        if (args.track) {
                            InitializeTracking(args.scope, args.itemId);
                        }

                        //Trigger Search Completed
                        searchFilter.SearchCompleted(data.FacetList);
                    });
            };
			
            this.SearchResultPageChanged = function (evt, param) {
                resultsCount: param.resultsCount;
            };

			eventManager.subscribe("search:update", this.ReloadSearchResults);

			$(args.scope).on("search:updated", this.SearchResultPageChanged);
			
			this.ReloadSearchResults(searchFilter.GetSearchQuery(), searchFilter.GetFilters());

			return args.IsExperienceEditorEditing === false ? new SearchResult(args.scope) : null;
		};

	});